import React from "react";
import styled from "styled-components";
import TableContainer from "../../elements/TableContainer";
import SubHeading from "../../elements/SubHeading";
import ActivityRow from "../../idea/ActivityRow";
import StockAction from "./StockAction";
import {OpenIdeasList} from "./OpenIdeasList";

const Container = styled.div`
    display: flex;
    flex-grow: 0;
    padding: 20px 30px;
`;

const OpenIdeasContainer = styled(TableContainer)`
    width: 300px;
    margin-right: 20px;
`;

const ContributorActivityContainer = styled(TableContainer)`
    width: 800px;
    flex-grow: 1;
`;

const StockActivity = ({stockDetails, ideaActions, activityLimit}) => {
    return <Container>
        <OpenIdeasContainer>
            <SubHeading>Open Ideas</SubHeading>
            <OpenIdeasList ideaType="Long" ideas={stockDetails.openIdeas.longs}
                           showDetail={ideaActions.showDetail}/>
            <OpenIdeasList ideaType="Short" ideas={stockDetails.openIdeas.shorts}
                           showDetail={ideaActions.showDetail}/>
        </OpenIdeasContainer>
        <ContributorActivityContainer>
            <SubHeading>Contributor Activity</SubHeading>
            {stockDetails.activity.slice(0, activityLimit).map((action, index) =>
                <ActivityRow dateTime={action.dateTime}
                             action={action.action}
                             key={index}
                             onClick={() => ideaActions.showDetail(action.ideaId)}>
                    <StockAction {...action} />
                </ActivityRow>
            )}
        </ContributorActivityContainer>
    </Container>;
};

export default StockActivity;